import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { VerizonReport, VerizonReportCreation } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  options?: Omit<UseMutationOptions<VerizonReport, Error, VerizonReportCreation, unknown>, 'mutationKey' | 'mutationFn'>
}

export const useNewVerizonReportRequest = ({
  options,
}: RequestParams = {}) => {
  const api = useApiInstance()

  return useMutation<VerizonReport, Error, VerizonReportCreation, unknown>(
    [Entities.VerizonReports, 'create'],
    async (payload: VerizonReportCreation) => {
      const { data } = await api.v1AdminVerizonReportsPost(payload)
      return data as VerizonReport
    },
    { ...options },
  )
}
